import Notification from './druid/types/Notification';
import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useSetNotification(): (notification: Notification) => void {
  return useWebChatAPIContext().setNotification;
}
